export const AppType = "winWidgets";
export const PageType = "winwidgetshp";
export const StartBoardId = "MicrosoftWindows.Client.WebExperience_cw5n1h2txyewy!Widgets!!com.msn.desktopfeed!!com.msn.desktopfeed";
export const StoreAppName = "MicrosoftWindows.Client.WebExperience_cw5n1h2txyewy!Widgets";
export const FeedsPackageAppName = "MicrosoftWindows.Dashboard_cw5n1h2txyewy!Widgets";
export const CalendarWidgetId = "com.microsoft.calendar";
export const ToDoWidgetId = "com.microsoft.todo";
